import PropTypes from 'prop-types';

const SchedulerPostSettingsBg = ({ width = 24, height = 18, darkMode = false, ...restProps }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 18"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}>
            <g id="🤖-Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Settings" fill={darkMode ? '#0f121e' : '#FFFFFF'}>
                    <path
                        d="M10.9870739,14.0001662 C7.12108065,14.0001662 3.9870739,10.8661595 3.9870739,7.00016623 L3.9870739,3.0560544 C3.9870739,1.0036589 2.65804927,-0.0149704914 0,0.00016622734 L0,0.00016622734 L23.9870739,0.000166227341 L23.9870739,14.0001662 L23.986881,14 L23.9873467,17.5885754 C23.9590855,17.4431003 23.9449549,17.2656487 23.9449549,17.0562206 C23.9449549,15.0700314 22.7002908,14.0519895 20.2109627,14.0020948 L19.957881,14.0003325 L10.9870739,14.0001662 Z"
                        id="BGSettings"></path>
                </g>
            </g>
        </svg>
    );
};

SchedulerPostSettingsBg.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    darkMode: PropTypes.bool
};

export default SchedulerPostSettingsBg;
